import { useContext } from 'react';

import { useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormFieldGroup from '../../../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import PhotoModelFields from '../../../formFields/photoModelFields/photoModelFields';
import ProhibitionsField from '../../../formFields/prohibitionsField/prohibitionsField';
import GuideImageField from '../../../../../formFields/guideImageField/guideImageField';

const PhotoGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { brand } = useContext(CampaignFormContext);

  return (
    <CampaignFormFieldGroup
      label={languageTexts.campaign_form_photo_guidelines_group_name}
      wrapperClassName="!gap-7"
    >
      {/* 필수 사진을 알려주세요. */}
      <PhotoModelFields
        label={`${brand.isWholesale ? '1' : '2'}. ${
          languageTexts.campaign_form_photo_guidelines_mandatory_photos_label
        }`}
        description={
          languageTexts.campaign_form_photo_guidelines_mandatory_photos_description
        }
      />

      {/* 금지사항 */}
      <ProhibitionsField
        prohibitionsOptionNames={[
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.OTHER_PEOPLE,
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.MIRROR_SELFIE,
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.MASK,
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.INDOORS,
        ]}
      />

      {/* 추가 이미지 가이드 */}
      {!brand.isWholesale && (
        <GuideImageField
          label={languageTexts.create_photo_form_image_guideline}
          description={languageTexts.create_photo_form_image_guideline_fashion}
          uploadButtonText="+"
        />
      )}
    </CampaignFormFieldGroup>
  );
};

export default PhotoGuidelineFieldGroup;
